import Image from 'next/image'

type Props = {
  name: string
}

const DIMENSIONS = {
  health: {
    width: '38',
    height: '30',
  },
  weightloss: {
    width: '38',
    height: '30',
  },
  both: {
    width: '38',
    height: '30',
  },
}

export default function LandingButtonSvg({ name }: Props): JSX.Element {
  if (name === 'continue') {
    return null
  }

  const dimension = DIMENSIONS[name]

  return (
    <div className="text-gold-100 group-hover:text-gold-200 active:text-gold-300 focus:outline-none ltr:mr-4 rtl:ml-4">
      <Image
        src={`/assets/o_series/landing/${name}.svg`}
        width={dimension.width}
        height={dimension.height}
      />
    </div>
  )
}
